import { render, staticRenderFns } from "./guideManage.vue?vue&type=template&id=897ace18&scoped=true&"
import script from "./guideManage.vue?vue&type=script&lang=js&"
export * from "./guideManage.vue?vue&type=script&lang=js&"
import style0 from "./guideManage.vue?vue&type=style&index=0&id=897ace18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897ace18",
  null
  
)

export default component.exports